module.exports = __webpack_public_path__ + "img/rules.ee7f9d4b.png";